import React, { createContext, useState, useContext, useEffect } from 'react';
import * as endpoints from '../utils/endpoints';
import api from '../utils/axios';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import * as AuthAction from '../redux/actions/authActions';
import * as LocalStorage from '../utils/localStorage';
import unAuthorizedPages from '../utils/unAuthorizedPages';
import Router, { useRouter } from 'next/router';
// import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { useCheckAuthorizedPage } from '../utils/useCheckAuthorizedPage';
const authPages = ['/signin', '/verify_phone'];
const completeDataPages = ['/profileupdate'];
const AuthContext = createContext({});

const AuthProviderContext = ({
  children,
  setUserData,
  verifyPhoneRequest,
  setVerifyPhoneError,
  verifyPhoneSuccess,
  prevPath,
}) => {
  const router = useRouter();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { doesPageRequireAuth } = useCheckAuthorizedPage();
  useEffect(() => {
    const pathname = Router?.router?.pathname;
    const isInit = LocalStorage.checkIsInit();
    if (!unAuthorizedPages.includes(pathname) && !isInit) {
      Router.push('/');
    }
    if (
      !unAuthorizedPages.includes(pathname) &&
      user &&
      !user.is_completed_profile &&
      isInit &&
      pathname !== '/profileupdate'
    ) {
      Router.push('/profileupdate');
    }
    if (authPages.includes(pathname) && isInit && user) {
      if (user?.is_completed_profile) {
        Router.push('/');
      } else {
        Router.push('/profileupdate');
      }
    }
    if (
      completeDataPages.includes(pathname) &&
      isInit &&
      user?.is_completed_profile
    ) {
      Router.push('/');
    }
  });
  const loadUserFromCookies = async () => {
    try {
      const token = Cookies.get('token') || router?.query?.id_token;
      if (token) {
        api.defaults.headers.Authorization = `Bearer ${token}`;

        const userRes = await api.post(endpoints.PERSONAL_INFO);
        const user = userRes?.data?.data && userRes?.data?.data[0];

        if (user) {
          const {
            id,
            phone,
            phone_code,
            country_code,
            user_type,
            username,
            email,
          } = user;
          LocalStorage.setUserId(id);
          LocalStorage.setName(username);
          LocalStorage.setUserName(username);
          LocalStorage.setMobile(phone, country_code || phone_code);
          LocalStorage.setPhone(phone, country_code || phone_code);
          LocalStorage.setUserTypeIntercom(user_type);
          LocalStorage.setEmail(email);
          LocalStorage.setIsInit(true);
          setUser(user);
          setUserData({ ...user, token });
          // datadogRum.setUser({
          //   id: id,
          //   name: username,
          //   phone: `${country_code || phone_code}${phone}`,
          //   user_type: user_type,
          // });
        }
        setLoading(false);
      } else if (!doesPageRequireAuth) {
        return;
      } else {
        const isInit = LocalStorage.checkIsInit();
        if (isInit) {
          logout();
        }
      }
    } catch (error) {
      setLoading(false);
      datadogLogs.logger.error('Auth Error happened', {
        user,
        page: window.location.pathname,
        error,
        errorResponse: error.response,
        errorMessage: error.message,
      });
      if (!doesPageRequireAuth) return;

      logout();
    }
  };

  useEffect(() => {
    if (window && typeof window.ReactNativeWebView !== 'undefined') return;
    else loadUserFromCookies();
  }, []);

  const login = async (phone, verification_code, phoneCode) => {
    try {
      verifyPhoneRequest();
      const rToken = Cookies.get('rToken');
      const res = await api.post(endpoints.LOGIN, {
        verification_code,
        phone,
        country_code: phoneCode,
      });
      const token = res.data?.data?.token;
      const userData = res.data?.data?.user;
      const userId = userData.id;
      const userType = userData.user_type;
      const is_supporting_student = userData.details?.is_supporting_student;

      if (token) {
        Cookies.set('token', token, { expires: 600000 });
        Cookies.set('user_id', userId, { expires: 600000 });
        Cookies.set('user_type', userType, { expires: 600000 });
        Cookies.set('is_supporting_student', is_supporting_student, {
          expires: 600000,
        });

        api.defaults.headers.Authorization = `Bearer ${token}`;
        //    const userRes = await api.post(endpoints.PERSONAL_INFO, { ...data, user_id });

        const {
          id,
          phone,
          phone_code,
          country_code,
          user_type,
          username,
          name,
          email = '',
        } = userData;
        LocalStorage.setUserId(id);
        LocalStorage.setName(name);
        LocalStorage.setUserName(username);
        LocalStorage.setMobile(phone, country_code || phone_code);
        LocalStorage.setPhone(phone, country_code || phone_code);
        LocalStorage.setUserTypeIntercom(user_type);
        LocalStorage.setEmail(email);
        LocalStorage.setIsInit(true);

        setUser(user);
        setUserData({ ...user, token });
        verifyPhoneSuccess();
        reRunIntercom();
        // check the intercom messenger is open
        if (
          document.getElementsByClassName('intercom-messenger-frame').length
        ) {
          Intercom('showMessages');
        }

        setUser(userData);
        setUserData({ ...userData, token });
        verifyPhoneSuccess();

        if (!userData.is_completed_profile) {
          Router.push('/profileupdate');
        } else {
          Router.push('/');
        }
      }
      setLoading(false);

      return res.data;
    } catch (error) {
      setVerifyPhoneError(error?.response?.data?.error || error.message);
      return error;
    }
  };

  const logout = () => {
    datadogLogs.logger.info('User logged out successfully', {
      user,
      page: window.location.pathname,
    });
    Cookies.remove('token');
    Cookies.remove('user_id');
    Cookies.remove('user_type');
    // clear the session when user logs out
    Cookies.remove('intercom-session-d2a055l8');
    Cookies.remove('intercom-id-d2a055l8');
    LocalStorage.setIsInit(false);
    LocalStorage.clearLocalStorage();
    setUser(null);
    setUserData({});
    if (typeof Intercom === 'function') Intercom('shutdown');
    if (typeof reRunIntercom === 'function') reRunIntercom();
    window.location.href = '/signin';
  };

  return (
    <AuthContext.Provider
      value={{
        prevPath,
        isAuthenticated: !!user,
        user,
        login,
        loading,
        logout,
        isCompletedInfo: user?.is_completed_profile,
        setUser: (data) => setUser(data),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const mapDispatchToProps = {
  setUserData: AuthAction.setUserData,
  setVerifyPhoneError: AuthAction.setVerifyPhoneError,
  verifyPhoneRequest: AuthAction.verifyPhoneRequest,
  verifyPhoneSuccess: AuthAction.verifyPhoneSuccess,
};

const mapStateToProps = (state) => ({
  prevPath: state.auth.prevPath,
});
export const AuthProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthProviderContext);

const useAuth = () => {
  const context = useContext(AuthContext);
  return context;
};

export default useAuth;
